import { setNetwork } from 'app/scripts/services/app-state';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { TDispatch, updateAppState } from 'state';
import { networkVersion } from 'state/app-state/api';
import { setNetworkIdInjectorValue } from 'fed-common/src/services/interceptors/network-id-injector';

const changeNetwork = ({ networkId, spotId }: { networkId: string; spotId?: string }) => {
  return async (dispatch: TDispatch): Promise<void> => {
    if (!networkId || (networkId !== 'spotim' && !spotId)) {
      throw new Error();
    }

    try {
      const networks = await networkVersion(networkId, spotId).catch(console.error);
      const networkData = (networks || {})[networkId];
      setNetwork(networkData);
      setNetworkIdInjectorValue(networkId);
      dispatch(updateAppState({ network: networkData }));
    } catch (error) {
      const errorMessage = `Failed to change network to networkId-${networkId}, spotId-${spotId}`;
      console.error(errorMessage, error);
      ErrorNotifier.notifyError(new Error(`${errorMessage}, e: ${error}`));
    }
  };
};

export default changeNetwork;
